import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(
	searchTerm: string,
	showOnlyDeleted: boolean
): Promise<Optional<ResponseUnit[]>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Unit/StartingWith`;
	const params: Parameter = {
		SearchTerm: searchTerm,
		ShowOnlyDeleted: showOnlyDeleted,
	};
	return axios.get(url, { params: params }).toOptionalMapped((x) => x.data.units);
}

interface Parameter {
	SearchTerm: string;
	ShowOnlyDeleted: boolean;
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	units: ResponseUnit[];
};

export type ResponseUnit = {
	id: string;
	description: string;
};
